<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Etkinlikte Neler Yaptık?" />
        <Gallery pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import Gallery from '../Gallery/Gallery'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'GalleryPage',
    components: {
    Navbar,
    PageTitle,
    Gallery,
    Footer,
    BuyNow
},
}
</script>